/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/11/20
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import type { Location } from 'react-router-dom';

type Props = {
  component: React.ComponentType<any>,
  path: string,
  isAuthorized: boolean,
  redirect: string,
};

type RouteProps = {
  location: Location,
};

const ProtectedRoute = ({
  component, path, isAuthorized, redirect,
}: Props) => (
  <Route
    path={path}
    render={(props: RouteProps) => (
      (isAuthorized) ?
        React.createElement(component, props) :
        <Redirect to={{ pathname: redirect, state: { from: props.location.pathname } }} />
    )}
  />
);

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./js/components/support/routing/ProtectedRoute/index.jsx